import { siteInfo } from "@/mocks/site";
import NewsletterForm from "@/components/feature/NewsletterForm";

export default function SubscribeCta() {
  return (
    <section id="newsletter" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="relative overflow-hidden rounded-xl2 border border-primary-200 bg-primary-50 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-accent-200/60 blur-3xl"></div>
          <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
                <span className="h-1 w-6 rounded-full bg-primary-500"></span>
                NEWSLETTER
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                每周一封，把乐子送到你邮箱
              </h2>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                订阅「瓜乐圈周报」，我们会在每周五把这一周最值得看的名场面、爆笑高能和小甜瓜整理成一封邮件，
                只推乐子，不发广告，随时可以退订。
              </p>
              <p className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-mail-line"></i>
                  {siteInfo.email}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-shield-check-line"></i>
                  邮箱仅用于发送周报
                </span>
              </p>
            </div>
            <div className="rounded-xl2 border border-background-200 bg-background-50 p-6">
              <NewsletterForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}